import { piAhGoBack, piAhFileUrl, piAhForTableList, piAhGetPrivilegeVoObj, } from "@/utils/ajaxdata.helper";
import { piOhForNull } from "@/utils/object.helper";
/**
 * 公用方法库，以前不规范，方法全写的 common 里了，页面上注释又显示不出来，
 * 然后就拆分一个个引用，下面这些用的地方有点多，有的又在 html 代码里使用，不想一个个引入了，就留几个下来
 */
const common = {
    goBack: piAhGoBack,
    fileUrl: piAhFileUrl,
    forTableList: piAhForTableList,
    getPrivilegeVoObj: piAhGetPrivilegeVoObj,
    forNull: piOhForNull,
};
export default common;
